document.addEventListener('DOMContentLoaded', () => {
  const slider = new Swiper('#team-slider', {
    slidesPerView: 2,

    loop: false,
    grabCursor: true,
    pagination: {
      el: document.querySelector('.team-slider__control .control .control__pagination'),
      type: 'fraction',
    },
    lazy: {
      loadPrevNext: true,
      checkInView: true,
    },
    navigation: {
      nextEl: document.querySelector('.team-slider__control .control__arrow--next'),
      prevEl: document.querySelector('.team-slider__control .control__arrow--prev'),
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
      },
      490: {
        slidesPerView: 2,
      },
      640: {
        slidesPerView: 1,
      },
      992: {
        slidesPerView: 2,
      },
    },
  });
  const sliderProfileList = new Swiper('#lector-profile-list', {
    loop: false,
    grabCursor: true,
    pagination: {
      el: document.querySelector('.team-slider__control .control .control__pagination'),
      type: 'fraction',
    },
    lazy: {
      loadPrevNext: true,
      checkInView: true,
    },
    navigation: {
      nextEl: document.querySelector('.team-slider__control .control__arrow--next'),
      prevEl: document.querySelector('.team-slider__control .control__arrow--prev'),
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
      },
      490: {
        slidesPerView: 2,
      },
    },
  });
});
